export const shouldSignOutUnsupportedTorchTenant = ({
  isFetched,
  hasError,
  isTerraUser,
  hasAccessToTerraTenant,
  skipCheck,
  currentTenantId,
  tenantIds,
}: {
  isFetched: boolean;
  hasError: boolean;
  isTerraUser: boolean;
  hasAccessToTerraTenant: boolean;
  skipCheck: boolean;
  currentTenantId: string | undefined;
  tenantIds: ReadonlySet<string>;
}): boolean => {
  if (
    !isFetched ||
    hasError ||
    isTerraUser ||
    hasAccessToTerraTenant ||
    skipCheck ||
    !currentTenantId
  ) {
    return false;
  }

  return !tenantIds.has(currentTenantId);
};
